import { render, staticRenderFns } from "./SaleEmailItem.vue?vue&type=template&id=1f66a823&scoped=true&"
import script from "./SaleEmailItem.vue?vue&type=script&lang=js&"
export * from "./SaleEmailItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleEmailItem.vue?vue&type=style&index=0&id=1f66a823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66a823",
  null
  
)

export default component.exports